import React, { Fragment, Component } from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import Responsive from 'components/Responsive'
import Logo from 'components/Logo'
import navStyles from 'styles/common/nav'
import MEDIA from 'styles/media'
import Nav from './components/Nav'
import Tools from './components/Tools'
import Hamburger from './components/Hamburger'
import MobileNavOverlay from './components/MobileNavOverlay'
import { MobileNavContext } from './contexts/mobile-nav'

const StyledNav = styled.nav`
  ${navStyles};
  position: sticky;
  z-index: 5000;

  ${MEDIA.mobile} {
    justify-content: space-between;
    padding: 0 22px;
  }
`

const BodyOverflowHidden = createGlobalStyle`
  body {
    overflow: hidden;
  }
`

class NavBar extends Component {
  handleClick = () => this.setState({ open: !this.state.open })

  state = {
    open: false,
    onClick: this.handleClick
  }

  render() {
    const { open, onClick } = this.state

    return (
      <Fragment>
        {open && <BodyOverflowHidden />}
        <StyledNav>
          <Logo />
          <Responsive.desktop>
            <Nav isStory={this.props.isStory} />
            <Tools />
          </Responsive.desktop>
          <Responsive.mobile>
            <Hamburger open={open} onClick={onClick} />
          </Responsive.mobile>
        </StyledNav>
        <MobileNavContext.Provider value={this.state}>
          <MobileNavOverlay open={open} />
        </MobileNavContext.Provider>
      </Fragment>
    )
  }
}

export default NavBar



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/index.js